import { render } from "./FormativeActions.vue?vue&type=template&id=99003078"
import script from "./FormativeActions.vue?vue&type=script&lang=js"
export * from "./FormativeActions.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./FormativeActions.vue?vue&type=style&index=1&id=99003078&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\frontCode\\GN-Students\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__